import React,{useCallback,useState, useEffect,useRef} from 'react'
import {
	useSelector,
	useDispatch
} from 'react-redux';
import {Link} from "react-router-dom";
import $ from 'jquery'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Card from 'react-bootstrap/Card'
import {fullBasePath} from '../../util/util'
import classes from './PhotoReel.module.css'
import PoseCam from  '../poseCam/PoseCam'
import {toggleShow,setPose,showWithSettings} from '../poseCam/poseCamSlice'
import {getPicturesByDate, deletePicture} from '../photoReel/photoReelSlice'
import {
	getAllClients,
	selectTrainerParam
} from '../users/usersSlice.js'
import {capitalize} from '../../util/util.js'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
const PhotoReel = props => {
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const dateGroups = useSelector(state=>state.photoReel.picsByDate)
	const newPic = useSelector(state => state.photoReel.newPic)
	const isTrainer = useSelector(state => state.users.current_user.account_type) === 'trainer'
	const trainerParam = useSelector(selectTrainerParam)

	const url = new URL(window.location.href);
	const client_id = url.searchParams.get("client");

	useEffect(() => {
		if(isTrainer){
			dispatch(getAllClients())
		}
	},[])
	const clients =useSelector(state => state.users?.clients?.entities)
	const [client, setClient] = useState(undefined)
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		setIsLoading(true)
		if(isTrainer){
			// setClient(clients[client_id])
			dispatch(getPicturesByDate(client_id)).then(()=>setIsLoading(false))

		} else {
			dispatch(getPicturesByDate()).then(()=>setIsLoading(false))
		}
	}, [newPic])

	useEffect(() => {
		setClient(clients[client_id])
	},[clients, client_id])


	//Modal
	const [show, setShow] = useState(false);
	const handleClose = () => {
		setPicID("");
		setShow(false);
	}
	const handleShow = () => setShow(true);

	const [picID, setPicID] = useState("") //id of pic to delete

	// useEffect(() => {dispatch(getPicturesByDate())}, [newPic])

	const poseNameMap = ['front','side','back','other']
	return (
		<div className="pt-2 px-2 px-md-3">
			{isTrainer && client !==undefined ? 
			<>
				<strong style={{lineHeight:'1.5'}}>{capitalize(client?.user_name)}'s Progress Photos</strong>
				<hr/>
			</>
			:
			<>
				<strong style={{lineHeight:'1.5'}}>Progress Photos</strong>
				<hr/>
			</>
			}
			<PoseCam/>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Confirm Delete?</Modal.Title>
				</Modal.Header>
				<Modal.Body>Are you sure you want to delete this photo?</Modal.Body>
				<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>
					Cancel
				</Button>
				<Button variant="primary" onClick={
					() => {
						statusDispatch(deletePicture(picID), "picture","delete");
						handleClose()
					}
				}>
					Delete
				</Button>
				</Modal.Footer>
      		</Modal>
			{/* <Link to="/viewPictures"> */}
			<Link to={isTrainer ? `/viewPictures?client=${client_id}&${trainerParam}` : "/viewPictures"}>
				<Button size="sm" className="mr-2" variant="outline-primary">
					Manage Photos
				</Button>
			</Link>
			<Button size="sm" variant="primary" onClick={()=>dispatch(showWithSettings({
				currentPose:1,
				date:new Date().toLocaleString()
			}))}>
				Take Progress Photo
			</Button>


			{dateGroups.length<2 && !isTrainer ?
				<div className="text-center bg-light rounded mx-auto my-2 p-3 shadow">
					<h5>Tips</h5>
					<hr/>
					<p className="mb-1"><strong>Choose Plain Backdrop</strong></p>
					<p className="mb-3">Stand against a plain background like a white wall.</p>
					<p className="mb-1"><strong>Pose Naturally</strong></p>
					<p className="mb-3">Don't suck in or push out.</p>
					<p className="mb-1"><strong>Wear the Right Clothing</strong></p>
					<p className="mb-3">Wear athletic clothing or swimwear to get a clear view of body changes.</p>
					<p className="mb-1"><strong>Use Guiding Lines</strong></p>
					<p className="mb-3">Use the guiding lines that show up on your screen for consistent photos.</p>
				</div>
			:null}
			{isLoading ? 
			<div>
			<Spinner className="mt-2" animation="border" role="status" variant="primary" >
			</Spinner>
			</div>
			: 
			<>
			{dateGroups.length === 0 ? 
			<div style={{textAlign:'center'}}>
				<h4 style={{margin:'20px'}}>No progress photos yet</h4>
			</div>
			:
			<>
				{dateGroups.map(group=>{
					const {pictures} = group
					const other = pictures.find(pic=>pic.type == 0)
					const front = pictures.find(pic=>pic.type == 1)
					const side = pictures.find(pic=>pic.type == 2)
					const back = pictures.find(pic=>pic.type == 3)
					const picOrder = [front,side,back,other]
					return (
						<div>
							<div className="text-center">
								<div style={{
									background:'#00041c',
									padding:'8px 32px',
									color:'#ccc',
									borderRadius:'100px',
									display:'inline-block',
									margin:'auto',
									marginTop: "40px",
								}}>
									<i className="far fa-calendar mr-2" style={{color:'#338eff'}}/>
									{group.longDate}
								</div>
							</div>
							<div className={classes.PhotoRow}>
								{picOrder.map((pic,i)=>(
									<div>
										<div className="text-center">
											{poseNameMap[i]}
										</div>
										{
											Boolean(pic) ?
											<div className={classes.ImageBlock}>
												<button onClick={() => {setPicID(pic.pic_id); handleShow()} } className={classes.DeleteButton}>
													<i className="fa fa-trash" />
												</button>
												<img src={pic.img}/>
											</div> :
											((i+1)%4 !== 0 ?
												<button 
													onClick={
														()=>dispatch(showWithSettings({
															currentPose:(i+1)%4,
															date:(new Date(group.longDate)).toLocaleString()
														}))
													}
													className={classes.AddPic}>
														+
													</button>
											:null)
										}
									</div>
								))}
							</div>
						</div>
					)
				})}
				</>
			}
			</>
			}
		</div>
	)
}

export default PhotoReel